import andersen from "./andersen-immobilien.jpg";
import dkb from "./DKB-Grund-RGB.png";
import engelCommercial from "./engel-und-voelkers-commercial.png";
import engel from "./engel-und-voelkers.png";
import evernest from "./evernest.png";
import fabio from "./fabio-herrmann-immobilien.png";
import grundrissschmiede from "./grundriss_schmiede_logo.png";
import hamburgKinder from "./hamburg_macht_kinder_gesund_e_v.png";
import iwa from "./i-w-a-koschella-immobilien.jpg";
import immomates from "./immomates.png";
import kaufpreis from "./kaufpreis-aufteilung.png";
import kieplinski from "./kielpinski-immobilien.jpg";
import sothebys from "./Logo-Sothebys-Niedersachsen-Bremen.png";
import nordhaus from "./nordhaus.png";
import nutzungsdauer from "./nutzungsdauer.png";
import realEstate from "./real-estate.jpg";

export {
  andersen,
  dkb,
  engel,
  engelCommercial,
  evernest,
  fabio,
  grundrissschmiede,
  hamburgKinder,
  immomates,
  iwa,
  kaufpreis,
  kieplinski,
  nordhaus,
  nutzungsdauer,
  realEstate,
  sothebys,
};
